import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface FlattenPdfResponse {
  blob: Blob;
  filename: string;
}

@Injectable({
  providedIn: 'root'
})
export class FlattenPdfService {
  private readonly apiUrl = environment.flattenPdfApiUrl ?? '/api/flatten-pdf';

  constructor(private http: HttpClient) {}

  uploadAndFlatten(file: File): Observable<FlattenPdfResponse> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(this.apiUrl, formData, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(
      map((response) => {
        const blob = response.body as Blob;
        const disposition = response.headers.get('Content-Disposition');
        let filename = file.name.replace(/\.pdf$/i, '_flattened.pdf');
        if (disposition) {
          const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"'\s;]+)["']?/i)
            ?? disposition.match(/filename=["']?([^"'\s;]+)["']?/i);
          if (match?.[1]) {
            filename = decodeURIComponent(match[1].replace(/^["']|["']$/g, ''));
          }
        }
        return { blob, filename };
      })
    );
  }
}
